// extracted by mini-css-extract-plugin
export default {"page":"UnauthorizedPage_page__QZwep","UnauthorizedPage":"UnauthorizedPage_UnauthorizedPage__tWora"};